import React,{useState} from 'react';
import Info from "./Info"
import LatestRelease from "./LatestRelease";
import TopSong from "./TopSong";
import Albums from "./Albums";
import Description from "./Description";
import Single from "./Single";
import SimilarArtists from "./SimilarArtists";

function ArtistContent(props) {
    const [artist,setArtist] = useState({
        id:1,
        name: 'هیپاپولوژیست',
        type:'خواننده',
        description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.',
        image: 'https://prymie.com/wp-content/uploads/2023/03/727824597d680e80cb8f153240ab5818.1000x1000x1.jpg',
        latestRelease:{
            id:11,
            name:'ترکامون میشه رلیز',
            image:'https://i1.sndcdn.com/artworks-UJQ3hiqDaiogIeNo-OI2NYw-t500x500.jpg',
            date:'01/02/1402'
        },
        topSong:[
            {
                id:11,
                name:'ترکامون میشه رلیز',
                image:'https://i1.sndcdn.com/artworks-UJQ3hiqDaiogIeNo-OI2NYw-t500x500.jpg',
                date:'01/02/1402'
            },
            {
                id:11,
                name:'ترکامون میشه رلیز',
                image:'https://i1.sndcdn.com/artworks-UJQ3hiqDaiogIeNo-OI2NYw-t500x500.jpg',
                date:'01/02/1402'
            },
            {
                id:11,
                name:'ترکامون میشه رلیز',
                image:'https://i1.sndcdn.com/artworks-UJQ3hiqDaiogIeNo-OI2NYw-t500x500.jpg',
                date:'01/02/1402'
            },
            {
                id:11,
                name:'ترکامون میشه رلیز',
                image:'https://i1.sndcdn.com/artworks-UJQ3hiqDaiogIeNo-OI2NYw-t500x500.jpg',
                date:'01/02/1402'
            },
            {
                id:11,
                name:'ترکامون میشه رلیز',
                image:'https://i1.sndcdn.com/artworks-UJQ3hiqDaiogIeNo-OI2NYw-t500x500.jpg',
                date:'01/02/1402'
            },
            {
                id:11,
                name:'ترکامون میشه رلیز',
                image:'https://i1.sndcdn.com/artworks-UJQ3hiqDaiogIeNo-OI2NYw-t500x500.jpg',
                date:'01/02/1402'
            },
        ],
        albums:[
            {
                id:1,
                name:'کپسول',
                image: 'https://i1.sndcdn.com/artworks-IyXJUUiehrG7Eljy-jjqIDw-t500x500.jpg',
                yearRelease:'1401'
            },
            {
                id:2,
                name:'لیک شت',
                image: 'https://i1.sndcdn.com/artworks-zjTGGPs1G0N4RF2B-kKr9Zg-t500x500.jpg',
                yearRelease:'1401'
            },
            {
                id:3,
                name:'نسخه',
                image: 'https://i1.sndcdn.com/artworks-oykQ7nbGBqhvDSkj-BxDEIA-t500x500.jpg',
                yearRelease:'1401'
            },
            {
                id:1,
                name:'کپسول',
                image: 'https://i1.sndcdn.com/artworks-IyXJUUiehrG7Eljy-jjqIDw-t500x500.jpg',
                yearRelease:'1401'
            },
            {
                id:2,
                name:'لیک شت',
                image: 'https://i1.sndcdn.com/artworks-zjTGGPs1G0N4RF2B-kKr9Zg-t500x500.jpg',
                yearRelease:'1401'
            },
            {
                id:3,
                name:'نسخه',
                image: 'https://i1.sndcdn.com/artworks-oykQ7nbGBqhvDSkj-BxDEIA-t500x500.jpg',
                yearRelease:'1401'
            },
            {
                id:1,
                name:'کپسول',
                image: 'https://i1.sndcdn.com/artworks-IyXJUUiehrG7Eljy-jjqIDw-t500x500.jpg',
                yearRelease:'1401'
            },
            {
                id:2,
                name:'لیک شت',
                image: 'https://i1.sndcdn.com/artworks-zjTGGPs1G0N4RF2B-kKr9Zg-t500x500.jpg',
                yearRelease:'1401'
            },
            {
                id:3,
                name:'نسخه',
                image: 'https://i1.sndcdn.com/artworks-oykQ7nbGBqhvDSkj-BxDEIA-t500x500.jpg',
                yearRelease:'1401'
            },
        ],
        singleSong:[
            {
                id:11,
                name:'تکذیب',
                image:'https://i1.sndcdn.com/artworks-v5f1u4GcS47Iqssn-n3IyIA-t200x200.jpg',
                date:'01/02/1402'
            },
            {
                id:11,
                name:'شنبه',
                image:'https://i1.sndcdn.com/artworks-nYmiBBCrVjqqt4rz-sEyFQQ-t200x200.jpg',
                date:'01/02/1402'
            },
            {
                id:11,
                name:'بابلسر داره کلاب',
                image:'https://i1.sndcdn.com/artworks-tzxomBI2A2VQsIuL-YUWL7g-t200x200.jpg',
                date:'01/02/1402'
            },
            {
                id:11,
                name:'1402',
                image:'https://i1.sndcdn.com/artworks-fIZTsNkeXPfZN8X5-5u6teg-t200x200.jpg',
                date:'01/02/1402'
            },
            {
                id:11,
                name:'گیزه',
                image:'https://i1.sndcdn.com/artworks-vJssdqx6anQgqEzb-uzYpxw-t200x200.jpg',
                date:'01/02/1402'
            },
            {
                id:11,
                name:'باد پولی',
                image:'https://i1.sndcdn.com/artworks-wg2wOVDGlESLuT7B-NzjkVg-t200x200.jpg',
                date:'01/02/1402'
            },
        ],
        similarArtists:[
            {
                id: 1,
                name: 'اشکان کاگان',
                image: 'https://i1.sndcdn.com/avatars-s93kdCyXjzwF81o5-KNxcBw-t200x200.jpg',
            },
            {
                id: 1,
                name: 'گاد پوری',
                image: 'https://i1.sndcdn.com/avatars-fcOClPItxSBri2Vb-AYK65w-t200x200.jpg',
            },
            {
                id: 1,
                name: 'سپهر خلصه',
                image: 'https://i1.sndcdn.com/avatars-000412991880-3chsnh-t200x200.jpg',
            },
            {
                id: 1,
                name: 'چرسی',
                image: 'https://i1.sndcdn.com/avatars-5RvI3523KqyiT8LN-dGjj2Q-t200x200.jpg',
            },
            {
                id: 1,
                name: 'یانگ صادن',
                image: 'https://i1.sndcdn.com/avatars-QdME5EyYTJht6gyl-BgRA4w-t200x200.jpg',
            },
            {
                id: 1,
                name: 'سینازا',
                image: 'https://i1.sndcdn.com/avatars-Kzjm7TxIgoDE1pzj-equEpg-t200x200.jpg',
            },
            {
                id: 1,
                name: 'اشکان کاگان',
                image: 'https://i1.sndcdn.com/avatars-s93kdCyXjzwF81o5-KNxcBw-t200x200.jpg',
            },
            {
                id: 1,
                name: 'گاد پوری',
                image: 'https://i1.sndcdn.com/avatars-fcOClPItxSBri2Vb-AYK65w-t200x200.jpg',
            },
            {
                id: 1,
                name: 'سپهر خلصه',
                image: 'https://i1.sndcdn.com/avatars-000412991880-3chsnh-t200x200.jpg',
            },
            {
                id: 1,
                name: 'چرسی',
                image: 'https://i1.sndcdn.com/avatars-5RvI3523KqyiT8LN-dGjj2Q-t200x200.jpg',
            },
            {
                id: 1,
                name: 'یانگ صادن',
                image: 'https://i1.sndcdn.com/avatars-QdME5EyYTJht6gyl-BgRA4w-t200x200.jpg',
            },
            {
                id: 1,
                name: 'سینازا',
                image: 'https://i1.sndcdn.com/avatars-Kzjm7TxIgoDE1pzj-equEpg-t200x200.jpg',
            },
            {
                id: 1,
                name: 'اشکان کاگان',
                image: 'https://i1.sndcdn.com/avatars-s93kdCyXjzwF81o5-KNxcBw-t200x200.jpg',
            },
            {
                id: 1,
                name: 'گاد پوری',
                image: 'https://i1.sndcdn.com/avatars-fcOClPItxSBri2Vb-AYK65w-t200x200.jpg',
            },
            {
                id: 1,
                name: 'سپهر خلصه',
                image: 'https://i1.sndcdn.com/avatars-000412991880-3chsnh-t200x200.jpg',
            },
            {
                id: 1,
                name: 'چرسی',
                image: 'https://i1.sndcdn.com/avatars-5RvI3523KqyiT8LN-dGjj2Q-t200x200.jpg',
            },
            {
                id: 1,
                name: 'یانگ صادن',
                image: 'https://i1.sndcdn.com/avatars-QdME5EyYTJht6gyl-BgRA4w-t200x200.jpg',
            },
            {
                id: 1,
                name: 'سینازا',
                image: 'https://i1.sndcdn.com/avatars-Kzjm7TxIgoDE1pzj-equEpg-t200x200.jpg',
            },
        ]
    })

    return (
        <div className='flex flex-col space-y-4 md:space-y-8 container mx-auto'>
            <Info image={artist.image} name={artist.name} type={artist.type}/>
            <Description description={artist.description}/>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 space-x-4 space-x-reverse">
                <TopSong topSong={artist.topSong}/>
                <LatestRelease latestRelease={artist.latestRelease}/>
            </div>
            <Albums data={artist.albums}/>
            <Single data={artist.singleSong}/>
            <SimilarArtists data={artist.similarArtists}/>
        </div>
    );
}

export default ArtistContent;